import { createFileRoute } from "@tanstack/react-router";
import GlassTileMosaics from "@/pages/GlassTileMosaics";
import { buildHead } from "@/lib/seo";

const OG_IMAGE =
  "https://vibe.filesafe.space/1779750798598342338/attachments/6cd7a94c-c25b-4556-9358-95411c8e61cf.png";

export const Route = createFileRoute("/glass-tile-mosaics")({
  head: () =>
    buildHead({
      title:
        "Luxury Glass Tile Mosaics for Pools & Waterlines | Precision Pavers & Pool Design",
      description:
        "Explore our exclusive collection of luxury hand-painted glass tile mosaics for pools, spas, waterlines, and raised walls in South Florida. Free estimates.",
      path: "/glass-tile-mosaics",
      ogImage: OG_IMAGE,
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Product",
          name: "Luxury Glass Tile Mosaics Collection",
          description:
            "Hand-painted glass tile mosaics in various formats and finishes for luxury swimming pool and spa designs.",
          brand: {
            "@type": "Brand",
            name: "Precision Pavers & Pool Design",
          },
          offers: {
            "@type": "AggregateOffer",
            priceCurrency: "USD",
            availability: "https://schema.org/InStock",
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://precisionpaverspools.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Glass Tile Mosaics",
              item: "https://precisionpaverspools.com/glass-tile-mosaics",
            },
          ],
        },
      ],
    }),
  component: GlassTileMosaics,
});
